<template >
  <div>
    <div class="container systemFile">
      <div class="firstRowBox">
        <div class="secondRow">
          <h1>
            <span class="icon"></span><span class="H1title">上级文件</span>
            <span class="icon1"></span>
            <span class="H1title1 pc">建设优势突出、特色鲜明的高水平大学</span>
            <el-button
              class="viewMoreBtn"
              type="danger"
              size="small"
              plain
              @click="doMore(2517, 2)"
              >查看更多</el-button
            >
          </h1>
          <div class="white-background">
            <el-row>
              <el-col
                :sm="24"
                v-for="(item, index) in topList"
                :key="item.id"
                class="news-item1"
                :class="{ first: index === 0 }"
              >
                <div @click="viewNews(item)">
                  <span class="time">{{ timeFormat(item.publish_time) }}</span>
                  <span class="teaTitle"> {{ item.title }}</span>
                  <div class="teaContent">{{ replaceTag(item.content) }}</div>
                </div>
              </el-col>
            </el-row>
          </div>
        </div>
      </div>
      <div class="mobile bgBox1"></div>
      <div class="secondRowBox">
        <div class="secondRow">
          <h1>
            <span class="icon"></span><span class="H1title">学校文件</span>
            <span class="icon1"></span>
            <span class="H1title1 pc">建设优势突出、特色鲜明的高水平大学</span>
            <el-button
              class="viewMoreBtn"
              type="danger"
              size="small"
              plain
              @click="doMore(2518, 2)"
              >查看更多</el-button
            >
          </h1>
          <div class="white-background">
            <el-row>
              <el-col
                :sm="24"
                v-for="(item, index) in secondList"
                :key="item.id"
                class="news-item1"
                :class="{ first: index === 0 }"
              >
                <div @click="viewNews(item)">
                  <span class="time">{{ timeFormat(item.publish_time) }}</span>
                  <span class="teaTitle"> {{ item.title }}</span>
                  <div class="teaContent">{{ replaceTag(item.content) }}</div>
                </div>
              </el-col>
            </el-row>
          </div>
        </div>
      </div>
    </div>
    <div class="firstBgBox pc"></div>
  </div>
</template>
<script>
import { getArticleList } from "@/api/api.js";
import config from "../config.js";
import util from "@/libs/util.js";
export default {
  data() {
    return {
      id: null,
      topList: [],
      secondList: [],
    };
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      getArticleList({orgId:config.relationId,menu_pid:0,menu_id:2517,pageNum:1,pageSize:5})
        .then((res) => {
          // 返回数据
          this.topList = res.result.list;
        })
        .catch((err) => {
          // 异常情况
          console.log(err);
        });
      getArticleList({orgId:config.relationId,menu_pid:0,menu_id:2518,pageNum:1,pageSize:5})
        .then((res) => {
          // 返回数据
          this.secondList = res.result.list;
        })
        .catch((err) => {
          // 异常情况
          console.log(err);
        });
    },
    getFirstPic: util.getFirstPic,
    replaceTag: util.replaceTag,
    getVideoPic: util.getVideoPic,
    getUnkownPic(url) {
      if (this.getFirstPic(url)) {
        return this.getFirstPic(url);
      } else {
        return this.getVideoPic(url);
      }
    },
    timeFormat(value) {
      return util.timeFormat(value, "yyyy-MM-dd");
    },
    doMore(menuId, type) {
      this.$router.push(`./news/${menuId}?type=${type}&label=4`);
    },
    viewNews(item) {
      this.$router.push(`./newsContent/${item.menu_id}/${item.id}?label=4`);
    },
  },
};
</script>
<style lang="scss" scoped>
.systemFile {
  position: relative;
  z-index: 9;
}
.firstBgBox {
  position: absolute;
  width: 100%;
  height: 700px;
  top: 0;
  background-image: url("~@/assets/images/kcsz/topBg.png");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: bottom;
  overflow-x: hidden;
}
.default-img .iconfont {
  width: 36px;
  height: 36px;
  font-size: 36px;
}
h1 {
  position: relative;
  padding-bottom: 50px;
  .icon {
    display: inline-block;
    width: 143px;
    height: 56px;
    background-color: #b92e32;
    position: absolute;
  }
  .icon:before {
    position: absolute;
    bottom: 0px;
    right: -10px;
    content: " ";
    display: block;
    width: 0;
    height: 0;
    border-color: #b92e32 transparent transparent #b92e32;
    border-style: solid;
    border-width: 28px 5px;
  }
  .icon1 {
    display: inline-block;
    width: 10px;
    height: 56px;
    background-color: #b92e32;
    position: absolute;
    left: 153px;
  }
  .icon1:before {
    position: absolute;
    bottom: 0px;
    right: 0px;
    content: " ";
    display: block;
    width: 0;
    height: 0;
    border-color: #fae9e3 transparent transparent #fae9e3;
    border-style: solid;
    border-width: 28px 5px;
  }
  .icon1:after {
    position: absolute;
    bottom: 0px;
    right: -10px;
    content: " ";
    display: block;
    width: 0;
    height: 0;
    border-color: #b92e32 transparent transparent #b92e32;
    border-style: solid;
    border-width: 28px 5px;
  }
  .H1title {
    font-size: 28px;
    color: #ffffff;
    line-height: 36px;
    position: absolute;
    top: 10px;
    left: 20px;
    z-index: 2;
  }
  .H1title1 {
    font-size: 18px;
    color: #444444;
    line-height: 27px;
    position: absolute;
    left: 190px;
    top: 15px;
  }
  .viewMoreBtn {
    position: absolute;
    right: 0px;
    top: 13px;
  }
}
.white-background {
  background-color: #fff;
  margin-top: 20px;
  padding: 20px;
  padding-bottom: 0px;
}
.white-background1 {
  background-color: #fff;
  margin-top: 20px;
  padding: 20px;
}
.bigNews {
  padding-bottom: 20px;
  border-bottom: 3px solid #b92e32;
}
.secondRow {
  .news-item1 {
    padding: 20px 0px;
    border-top: 1px dashed #b92e32;
  }
  .news-item1:hover {
    cursor: pointer;
  }
  .news-item1.first {
    padding-top: 0px;
    border-top: unset;
  }
  .time {
    display: inline-block;
    font-size: 16px;
    color: #ffffff;
    line-height: 24px;
    padding: 2px 8px;
    background: #d9ae73;
    border-radius: 4px;
  }
  .teaTitle {
    display: inline;
    font-size: 18px;
    color: #444444;
    letter-spacing: 0;
    line-height: 28px;
    font-weight: bold;
  }
  .teaContent {
    font-size: 14px;
    color: #969696;
    line-height: 21px;
    display: -webkit-box;
    text-overflow: ellipsis;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    white-space: normal;
    overflow: hidden;
  }
}
.firstRowBox {
  min-height: 100%;
  background-color: #f5f5f5;
  background-image: url("~@/assets/images/kcsz/topBg.png");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: top;
  overflow-x: hidden;
  padding-top: 40px;
  padding-bottom: 50px;
}
.secondRowBox {
  min-height: 100%;
  background-color: #f5f5f5;
  padding-bottom: 80px;
  h1 .icon1:before {
    border-color: #f5f5f5 transparent transparent #f5f5f5 !important;
  }
}
.title {
  font-size: 20px;
  height: 60px;
  color: #444444;
  letter-spacing: 0;
  line-height: 30px;
  font-weight: bold;
  display: -webkit-box;
  text-overflow: ellipsis;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  white-space: normal;
  overflow: hidden;
}
.time {
  margin: 10px 10px 14px 0px;
  font-size: 14px;
  color: #969696;
  letter-spacing: 0;
  line-height: 20px;
}
.content {
  height: 216px;
  font-size: 14px;
  color: #444444;
  letter-spacing: 0;
  line-height: 24px;
  text-overflow: ellipsis;
  white-space: normal;
  overflow: hidden;
}
.news-image1 {
  height: 320px;
}
.news-item {
  padding: 20px 0px;
  border-top: 1px dashed #b92e32;
  .time1 {
    font-size: 16px;
    color: #444444;
    letter-spacing: 0;
    line-height: 24px;
  }
  .title1 {
    font-size: 14px;
    color: #444444;
    letter-spacing: 0;
    line-height: 21px;
    display: -webkit-box;
    text-overflow: ellipsis;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    white-space: normal;
    overflow: hidden;
  }
}
.news-item.first,
.news-item.second {
  border-top: unset;
}
.news-item1:hover .teaTitle {
  color: #b92e32;
}
@media (max-width: 767px) {
  .systemFile {
    position: unset;
  }
  .secondRowBox h1 .icon1:before{
    border-color: #fff transparent transparent #fff !important;
  }
  h1 {
    .icon {
      width: 92px;
      height: 40px;
    }
    .icon::before {
      border-width: 20px 5px;
    }
    .icon1 {
      left: 103px;
      width: 10px;
      height: 40px;
    }
    .icon1::before {
      border-width: 20px 5px;
      border-color: #fff transparent transparent #fff !important;
      bottom:1px;
    }
    .icon1::after {
      border-width: 20px 5px;
    }
    .H1title {
      font-size: 18px;
      top: 3px;
      left: 10px;
    }
    .viewMoreBtn {
      top: 5px;
    }
  }
  .firstRowBox {
    background-color: #fff;
    background-image: unset;
    padding-top: 20px;
    padding-bottom: unset;
  }
  .secondRowBox {
    background-color: #fff;
    background-image: unset;
  }
  .white-background {
    padding: 0;
    margin-top: 6px;
  }
  // .title{
  //   font-size: 16px;
  //   line-height: 24px;
  //   margin-top: 12px;
  //   height: 48px;
  // }
  // .content{
  //   height: 48px;
  //    display: -webkit-box;
  //   text-overflow: ellipsis;
  //   -webkit-line-clamp: 2;
  //   -webkit-box-orient: vertical;
  //   white-space: normal;
  //   overflow: hidden;
  // }
  .bigNews {
    padding-bottom: 16px;
  }
  .news-item {
    padding: 16px 0px;
  }
  .news-item.second {
    border-top: 1px dashed #b92e32;
  }
  .bgBox1 {
    display: block !important;
    width: 100vw;
    height: 15px;
    margin-left: -15px;
    background-color: #f8f8f8;
  }
  .secondRowBox {
    padding: 16px 0px 30px 0px;
  }
  .secondRow {
    .news-item1 {
      position: relative;
      padding: 2px 0px 14px 0px;
    }
    .time {
      font-size: 12px;
      line-height: 18px;
      margin-bottom: 9px;
    }
    .teaTitle {
      display: inline-block;
      font-size: 14px;
      height: 20px;
      line-height: 20px;
      text-overflow: ellipsis;
      overflow: hidden;
      position: absolute;
      top: 13px;
    }
    .news-item1.first .teaTitle {
      top: 10px;
    }
    .teaContent {
      font-size: 12px;
      line-height: 18px;
    }
  }
}
</style>